<div class="qr-button-order">
  <span class="qr-button-order__hint">{{ config.hintLabel }}</span>
  <div class="qr-button-order__pill" role="group" [attr.aria-label]="config.hintLabel">
    <button
      type="button"
      class="qr-button-order__half"
      [class.qr-button-order__half--active]="selected === 'asc'"
      [disabled]="isDisabled"
      (click)="onAsc()"
      aria-label="Orden ascendente"
    >
      <qr-icon [name]="iconAsc" [color]="iconAscColor"></qr-icon>
    </button>
    <button
      type="button"
      class="qr-button-order__half"
      [class.qr-button-order__half--active]="selected === 'desc'"
      [disabled]="isDisabled"
      (click)="onDesc()"
      aria-label="Orden descendente"
    >
      <qr-icon [name]="iconDesc" [color]="iconDescColor"></qr-icon>
    </button>
  </div>
</div>
